import React from 'react'
import { AlertFilled, InfoCircleFilled, WifiOutlined, ThunderboltFilled } from '@ant-design/icons'
import { ReactComponent as CriticalIcon } from '../../assets/Icons_ Critical Fill.svg'
import styled from 'styled-components'
import Icon from '@ant-design/icons/lib/components/Icon'

type cardType = 'total' | 'active' | 'online' | 'urgent' | 'critical'
type HospitalStatsCardProp = {
  type: cardType
  text: string
  value: number | string | undefined
}

const cardColor = {
  total: '#8cc7ff',
  active: '#83f28f',
  online: '#eea0ff',
  urgent: '#ffdf7f',
  critical: '#ff8d8d',
}

const CardContainer = styled.div<{ type: cardType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 1 0;
  height: 100px;
  border-radius: 5px;
  color: white;
  border: 1px solid ${(prop) => cardColor[prop.type]};
  border-top: 20px solid ${(prop) => cardColor[prop.type]};
  color: black;
  position: relative;
  background: white;

  @media (max-width: 1200px) {
    width: 95%;   
  }
`

const CardTitle = styled.div`
  font-weight: 500;
  padding-bottom: 15px;
  font-size: 1.2em;
`

const CardNumber = styled.div`
  font-weight: 700;
  font-size: 2em;
`

const CardIconContainer = styled.div<{ type: cardType }>`
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 1.5em;
  color: ${(prop) => cardColor[prop.type]};
`

function HospitalStatsCard({ type, value, text }: HospitalStatsCardProp) {
  const cardIcon = {
    total: <InfoCircleFilled color='white' />,
    active: <ThunderboltFilled/>,
    online: <WifiOutlined />,
    critical: <Icon component={CriticalIcon} />,
    urgent: <AlertFilled />,
  }
  return (
    <CardContainer type={type}>
      <CardTitle>{text}</CardTitle>
      <CardNumber>{value ?? 0}</CardNumber>
      <CardIconContainer type={type}>{cardIcon[type]}</CardIconContainer>
    </CardContainer>
  )
}

export default HospitalStatsCard
